export const environment = {
  production: false,
  apiUrl: 'https://api.transformer.platform.qa.transflo.com/api/v1',
  portalSiteUrl: 'https://portal.qa.transflo.com/',
  portalApiUrl: 'https://gateway.qa.transflo.com/portal/graphql',
};
